import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, USER_RESOLVERS } from 'cpool-constants';
import { schemaUserResolver_Get } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys';

export const useUserData = (userId?: string) => {
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKeys.getUser(userId))]);
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.get,
        schema: schemaUserResolver_Get,
        searchParams: { id: userId, position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
